<template>
  <div class="info-box">
    <div class="overflow-y-auto">
      <el-form
        :model="state.model"
        label-width="auto"
        label-position="top"
        ref="formDom"
        size="large"
      >
        <ul v-if="state.supplier?.id" class="flex gap-x-3 items-center">
          <strong class="text-gray-800 text-lg">{{
            state.supplier?.name
          }}</strong>
          <text>{{ state.supplier?.number }}</text>
          <c_sex
            :value="state.supplier?.contact_title == '先生' ? '男' : '女'"
          />
          <text>{{ state.supplier?.contact_name }}</text>
          <text>{{ state.supplier?.contact_phone }}</text>
        </ul>
        <ul class="flex gap-x-5 mt-5">
          <el-form-item
            label="付款方式"
            prop="d_payment_type_id"
            :rules="[
              { required: true, message: '请选择成本类型', trigger: 'blur' },
            ]"
          >
            <el-select v-model="state.model.d_payment_type_id" class="!w-32">
              <el-option
                v-for="item in state.fkfs_data"
                :key="item"
                :label="item.name"
                :value="item.id"
              ></el-option>
              <template #footer>
                <el-button
                  plain
                  class="float-right mb-3"
                  size="small"
                  @click="onLoadFkfs()"
                >
                  刷新
                </el-button>
              </template>
            </el-select>
          </el-form-item>
          <el-form-item label="收款账户" v-if="state.supplier?.id">
            <el-select
              v-model="state.model.supplier_bank_account_id"
              class="!w-96"
            >
              <template #label="{ label, value }">
                <div class="flex gap-x-5 !w-full">
                  <text>{{ label.name + "-" + label.account }}</text>
                  <div
                    class="flex flex-col items-end flex-1 text-gray-400"
                    style="font-size: 12px"
                  >
                    {{ label.opening_bank }}
                  </div>
                </div>
              </template>
              <el-option
                v-for="item in state.gyszh_data"
                :key="item"
                :label="item"
                :value="item.id"
              >
                <div class="flex gap-x-5 !w-full">
                  <text>{{ item.name + "-" + item.account }}</text>
                  <div
                    class="flex flex-col items-end flex-1 text-gray-400"
                    style="font-size: 12px"
                  >
                    {{ item.opening_bank }}
                  </div>
                </div>
              </el-option>
              <template #footer>
                <el-button
                  plain
                  class="float-right mb-3"
                  size="small"
                  @click="onLoadGyszh"
                >
                  刷新
                </el-button>
              </template>
            </el-select>
          </el-form-item>
          <template v-else>
            <el-form-item label="收款人">
              <el-input v-model="state.model.bank_account_name"></el-input>
            </el-form-item>
            <el-form-item label="开户行">
              <el-input v-model="state.model.opening_bank"></el-input>
            </el-form-item>
            <el-form-item label="收款账户">
              <el-input v-model="state.model.bank_account"></el-input>
            </el-form-item>
          </template>
          <el-form-item label="申请说明" class="flex-1">
            <el-input v-model="state.model.intro"></el-input>
          </el-form-item>
        </ul>
        <ul class="grid grid-cols-3 gap-x-3">
          <el-form-item
            label="财务审批"
            prop="cfo"
            :rules="[
              { required: true, message: '请选择财务审批人', trigger: 'blur' },
            ]"
          >
            <c_userselect v-model="state.model.cfo" :type="2" />
          </el-form-item>
          <el-form-item
            label="总经理审批"
            prop="ceo"
            :rules="[
              {
                required: true,
                message: '请选择总经理审批人',
                trigger: 'blur',
              },
            ]"
          >
            <c_userselect v-model="state.model.ceo" :type="3" />
          </el-form-item>
          <el-form-item
            label="付款出纳"
            prop="cashier_admin_id"
            :rules="[
              { required: true, message: '请选择付款出纳', trigger: 'blur' },
            ]"
          >
            <c_userselect
              v-model="state.model.cashier_admin_id"
              :type="4"
              @change:item="
                (item) => {
                  state.model.cashier_department_id = item.department_id;
                }
              "
            />
          </el-form-item>
        </ul>
        <el-form-item label="附件">
          <template #label>
            <div class="flex items-center">
              <text>附件</text>
              <el-upload
                :show-file-list="false"
                :auto-upload="false"
                multiple
                :on-change="onFileChange"
              >
                <el-button type="primary" size="small" link icon="plus">
                  上传
                </el-button>
              </el-upload>
            </div>
          </template>
          <div class="w-full flex flex-wrap gap-x-5 gap-y-2">
            <li
              v-for="(file, index) in state.model.files"
              class="grid items-center hover:underline cursor-pointer text-green-700"
              style="grid-template-columns: 1fr auto"
              @click="$openFile(file.file_url)"
            >
              <text>{{ file.origin_filename }}</text>
              <el-icon
                color="#f00"
                @click.stop="state.model.files?.splice(index, 1)"
                class="hover:scale-110 text-red-400 cursor-pointer ml-2"
              >
                <Close />
              </el-icon>
            </li>
          </div>
        </el-form-item>
      </el-form>
      <ul class="flex">
        <li class="flex-1 font-bold">采购明细</li>
        <el-button color="#1e90ff" link @click="onSetDefault">
          自动填入
        </el-button>
      </ul>
      <strong></strong>
      <el-table
        :data="state.list_data"
        v-loading="!Array.isArray(state.list_data)"
        element-loading-background="rgba(0, 0, 0, 0.2)"
        :default-sort="{
          prop: state.params.sort_field,
          order: state.params.sort_value == 'desc' ? 'descending' : 'ascending',
        }"
      >
        <el-table-column
          fixed
          label="#"
          width="70"
          type="index"
          align="center"
        />
        <el-table-column>
          <template #header>
            <div
              class="c-table-col-header"
              label1="采购名称"
              label2="采购单号/类型/创建人"
            />
          </template>
          <template #default="{ row }">
            <c_tabgroup>
              <template #top>
                <strong>{{ row.name }}</strong>
                <text class="text-xs text-gray-400 ml-1">{{ row.number }}</text>
                <text class="text-xs text-gray-400 ml-1">
                  {{ row.d_cost_type_pname }}
                </text>
              </template>
              <template #bottom>
                <div class="flex items-center text-gray-400 text-xs gap-x-2">
                  <text class="text-sm text-gray-600">
                    {{ row?.add_admin_name }}
                  </text>
                  <text>{{ row?.add_department_name }}</text>
                  <text class="ml-1">{{ row?.create_time }} 创建</text>
                </div>
              </template>
            </c_tabgroup>
          </template>
        </el-table-column>
        <el-table-column
          label="采购说明"
          prop="intro"
          :width="160"
          align="center"
          :formatter="$tab_TextFormat"
        />
        <el-table-column label="采购总额" :width="120" align="center">
          <template #default="{ row }">
            <text class="text-red-500">{{ $priceFormat(row.amount) }}</text>
          </template>
        </el-table-column>
        <el-table-column label="付款中" :width="120" align="center">
          <template #default="{ row }">
            <text class="text-green-600">{{
              $priceFormat(row.paying_amount)
            }}</text>
          </template>
        </el-table-column>
        <el-table-column label="已付" :width="120" align="center">
          <template #default="{ row }">
            <text class="text-blue-400">{{
              $priceFormat(row.paid_amount)
            }}</text>
          </template>
        </el-table-column>
        <el-table-column
          label="应付"
          :width="120"
          align="center"
        >
          <template #default="{ row }">
            <text class="text-red-500 font-bold">{{
              $priceFormat(row.unpaid_amount)
            }}</text>
          </template>
        </el-table-column>
        <el-table-column label="本次付款" fixed="right" align="right">
          <template #default="{ row }">
            <el-input-number
              v-model="row.this_amount"
              :precision="2"
              class="number-input-left number-input-suffix !w-28"
              suffix="元"
              @focus="$onFocus"
              @change="onMoneyChange(row)"
            ></el-input-number>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="px-2.5 flex items-center mt-3">
      本次付款合计：<c_money
        class="flex-1"
        :key="state.total"
        :value="state.total"
        suffix
        :size="20"
        :prefix="false"
      />
      <el-button type="primary" size="large" @click="onSubmit">
        提交付款申请
      </el-button>
    </div>
  </div>
</template>

<script>
import { onMounted, reactive, ref } from "vue";
import { dic_getPaymentType } from "@/http/data";
import {
  meeting_purchase_applyPayment,
  meeting_purchase_applyPaymentSubmit,
} from "@/http/meeting";
import { attachment_upload } from "@/http/attachment";
import { ElMessage, ElMessageBox } from "element-plus";
import { toDecimal } from "@/utils/funcs";

class InitFormData {
  params = {
    page: 1,
  };
}

export default {
  props: {
    meeting_id: Number,
    ids: Array,
    supplier: Object,
  },
  setup(props, { emit }) {
    const formDom = ref(null);
    const state = reactive({
      ...new InitFormData(),
      model: {
        meeting_id: props.meeting_id,
        files: [],
      },
    });
    onMounted(() => {
      if (props.supplier?.id) {
        state.model.supplier_id = props.supplier?.id;
      }
      onLoadFkfs();
      onLoad();
    });

    //获取付款方式
    const onLoadFkfs = () => {
      dic_getPaymentType().then((res) => {
        if (res.status == 200) state.fkfs_data = res.data?.data || [];
      });
    };

    const onLoad = () => {
      if (props.ids?.length > 0) {
        delete state.list_data;
        meeting_purchase_applyPayment(props.ids).then((res) => {
          if (res.status == 200) {
            const {
              isSupplierPurchase,
              list,
              supplier,
              supplierBankAccountList,
            } = res.data?.data;
            state.list_data = list;
            state.is_supplier_purchase = isSupplierPurchase;
            if (isSupplierPurchase) {
              state.supplier = supplier;
              state.gyszh_data = supplierBankAccountList;
            }
          }
        });
      }
    };

    const onFileChange = (file) => {
      const formData = new FormData();
      formData.append("file[]", file.raw);
      attachment_upload(formData).then((res) => {
        if (res.status == 200) {
          state.model.files = [...state.model.files, ...res.data.data];
        }
      });
    };

    //金额更新
    const onMoneyChange = (row) => {
      if (row.this_amount > row.unpaid_amount) {
        ElMessage.warning("付款金额不能大于应付金额!");
        delete row.this_amount;
      }
      onBuildTotal();
    };

    //计算合计
    const onBuildTotal = () => {
      const total = state.list_data.reduce((pre, cur) => {
        return pre.plus(toDecimal(cur.this_amount?.toString() || "0"));
      }, toDecimal("0"));
      state.total = total;
    };

    //自动填写本次付款金额
    const onSetDefault = () => {
      state.list_data.forEach((row) => {
        row.this_amount = row.unpaid_amount;
      });
      onBuildTotal();
    };

    const onSubmit = () => {
      formDom.value.validate((valid) => {
        if (valid) {
          ElMessageBox.confirm(
            `本次申请付款金额为<strong class='text-red-500'>${state.total}元</strong>，是否立即提交`,
            "申请付款",
            {
              dangerouslyUseHTMLString: true,
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "warning",
            },
          ).then(() => {
            (state.model.attachment = state.model.files?.map((m) => m.id)),
              meeting_purchase_applyPaymentSubmit({
                ...state.model,
                data: state.list_data?.map((m) => {
                  return {
                    meeting_purchase_id: m.id,
                    this_amount: m.this_amount,
                  };
                }),
              }).then((res) => {
                if (res.status == 200) {
                  ElMessage.success("提交成功");
                  emit("confirm");
                }
              });
          });
        }
      });
    };

    return {
      state,
      props,
      formDom,
      onLoadFkfs,
      onLoad,
      onSubmit,
      onFileChange,
      onMoneyChange,
      onBuildTotal,
      onSetDefault,
    };
  },
};
</script>

<style lang="scss" scoped></style>
